import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { T4CommonModule } from '../../t4common/t4common';
import { AuthGuard, UIService } from 't4core';
import { DailySalesComponent } from './views/DailySales/DailySales.component'; 
import { TotalReportComponent } from './views/TotalReport/TotalReport.component';
import { DisabledObjectsReportComponent } from './views/DisabledObjectsReport/DisabledObjectsReport.component';
import { ObjectsReportComponent } from './views/ObjectsReport/ObjectsReport.component';
import { T4coreModule } from 't4core';
import { LateRentalsComponent } from './views/LateRentals/LateRentals.component';
import { ActiveRentalsComponent } from './views/ActiveRentals/ActiveRentals.component';
import { TransactionsComponent } from './views/Transactions/Transactions';
import { FleetOverviewComponent } from './views/FleetOverview/FleetOverview';
import { DashboardComponent } from './views/Dashboard/dashboard.component';
import { PTTransactionsComponent } from './views/PTTransactions/PTTransactions';
import { InsuranceReportComponent } from './views/InsuranceReport/InsuranceReport';
import { CSEventlogDialog } from './dialogs/CSEventlogDialog/CSEventlogDialog';
import { TireChangeComponent } from './views/TireChange/TireChange';
import { ProductOverviewComponent } from './views/ProductOverview/ProductOverview';
import { TrailerOverviewComponent } from './views/TrailerOverviewReport/TrailerOverviewReport';
import { EarningsPerRentalObjectComponent } from './views/EarningsPerRentalObject/EarningsPerRentalObject';
import { FleetAvailabilityComponent } from './views/FleetAvailability/FleetAvailability';
import { TrailerInspectionsComponent } from './views/TrailerInspections/TrailerInspections';
import { UsedPartsPerTrailerReportComponent } from './views/UsedPartsPerTrailerReport/UsedPartsPerTrailerReport';


@NgModule({
  declarations: [
    DashboardComponent,
    DailySalesComponent,
    TotalReportComponent,
    DisabledObjectsReportComponent, 
    ObjectsReportComponent,
    LateRentalsComponent,
    ActiveRentalsComponent,
    TransactionsComponent,
    FleetOverviewComponent,
    PTTransactionsComponent,
    InsuranceReportComponent,
    CSEventlogDialog,
    TireChangeComponent,
    ProductOverviewComponent,
    TrailerOverviewComponent,
    EarningsPerRentalObjectComponent,
    FleetAvailabilityComponent,
    TrailerInspectionsComponent,
    UsedPartsPerTrailerReportComponent
    ],
    imports: [
      T4CommonModule,
      T4coreModule,
        RouterModule.forChild([
            {
                path: 'Reports',
                data: {
                  index: 1000, title: "Reports", roles: ['LocationManager', 'Clerk', 'GroupManager', 'Admin', 'ServiceGuy'], icon: 'bar_chart'
                },
            children: [
              { path: '', redirectTo: 'Rentals', pathMatch: 'full' },
              //{
              //  path: "Dashboard",
              //  canActivate: [AuthGuard],
              //  component: DashboardComponent,
              //  data: { title: "Dashboard", toolTip: "Dashboard", roles: ['LocationManager', 'GroupManager', 'Admin', 'Sales'], icon: 'bar_chart' }
              //},
              {
                path: "Rentals",
                canActivate: [AuthGuard],
                data: { title: "Rentals", icon: 'today', roles: ['LocationManager', 'Admin', 'GroupManager', 'Clerk'] },
                children: [
                  { path: '', redirectTo: 'TotalReport', pathMatch: 'full' },
                  {
                    path: "TotalReport",
                    canActivate: [AuthGuard],
                    component: TotalReportComponent,
                    data: { title: "Rental report", icon: 'assignment', roles: ['LocationManager', 'GroupManager', 'Admin'] }
                  },
                  {
                    path: "ActiveRentals",
                    canActivate: [AuthGuard],
                    component: ActiveRentalsComponent,
                    data: { title: "Active rentals", icon: 'event_available', roles: ['LocationManager', 'GroupManager', 'Admin', 'Clerk', 'ServiceGuy'] }
                  },
                  {
                    path: "LateRentals",
                    canActivate: [AuthGuard],
                    component: LateRentalsComponent,
                    data: { title: "Late rentals", icon: 'assignment_late', roles: ['LocationManager', 'GroupManager', 'Admin', 'Clerk', 'ServiceGuy'] }
                  }
                ]
              },
              {
                path: "Financial",
                canActivate: [AuthGuard],
                data: { title: "Financial", icon: 'today', roles: ['LocationManager', 'Admin', 'GroupManager', 'Clerk'] },
                children: [
                  { path: '', redirectTo: 'FleetOverview', pathMatch: 'full' },
                  {
                    path: "FleetOverview",
                    canActivate: [AuthGuard],
                    component: FleetOverviewComponent,
                    data: { title: "Overview", icon: 'payments', roles: ['LocationManager', 'Admin', 'GroupManager'] }
                  },
                  {
                    path: "EarningsPerObject",
                    canActivate: [AuthGuard],
                    component: EarningsPerRentalObjectComponent,
                    data: { title: "Earnings per object", icon: 'payments', roles: ['LocationManager', 'Admin', 'GroupManager'] }
                  },
                  {
                    path: "Transactions",
                    canActivate: [AuthGuard],
                    component: TransactionsComponent,
                    data: { title: "Transactions", icon: 'payments', roles: ['LocationManager', 'Admin', 'GroupManager'] }
                  },
                  {
                    path: "DailySales",
                    canActivate: [AuthGuard],
                    component: DailySalesComponent,
                    data: { title: "Daily sales", icon: 'today', roles: ['LocationManager', 'Clerk'] }
                  },
                  {
                    path: "PTTransactions",
                    canActivate: [AuthGuard],
                    component: PTTransactionsComponent,
                    data: { title: "Paythrough transactions", icon: 'payments', roles: ['Admin'] }
                  },
                  {
                    path: "ProductOverview",
                    canActivate: [AuthGuard],
                    component: ProductOverviewComponent,
                    data: { title: "Product Overview", icon: 'folder_zip', roles: ['LocationManager', 'GroupManager'] }
                  }

                ]
              },
              {
                path: "Fleet",
                canActivate: [AuthGuard],
                data: { title: "Fleet", icon: 'today', roles: ['LocationManager', 'Admin', 'GroupManager', 'Clerk'] },
                children: [
                  { path: '', redirectTo: 'Trailers', pathMatch: 'full' },
                  {
                    path: "Trailers",
                    canActivate: [AuthGuard],
                    component: ObjectsReportComponent,
                    data: { title: "Brenderup trailers", icon: 'local_shipping', roles: ['GroupManager'] }
                  },
                  {
                    path: "DisabledTrailers",
                    canActivate: [AuthGuard],
                    component: DisabledObjectsReportComponent,
                    data: { title: "Disabled trailers", icon: 'report_off', roles: ['LocationManager', 'GroupManager', 'Admin', 'Clerk'] }
                  },
                   {
                     path: "TrailerOverview",
                    canActivate: [AuthGuard],
                     component: TrailerOverviewComponent,
                     data: { title: "Trailer Performance", icon: 'summarize', roles: ['LocationManager', 'GroupManager', 'Admin', 'Clerk'] }
                  },
                  {
                    path: "Availability",
                    canActivate: [AuthGuard],
                    component: FleetAvailabilityComponent,
                    data: { title: "Availability", icon: 'stacked_bar_chart', roles: ['LocationManager', 'GroupManager', 'Admin', 'Clerk'] }
                  },
                  {
                    path: "UsedPartsPerTrailer",
                    canActivate: [AuthGuard],
                    component: UsedPartsPerTrailerReportComponent,
                    data: { title: "Used parts per trailer", icon: 'build', roles: ['LocationManager', 'GroupManager', 'Admin', 'Clerk'] }
                  }
                ]
              },
              {
                path: "TrailerInspections",
                component: TrailerInspectionsComponent,
                data: { title: "Trailer Inspections", icon: 'group', roles: ['LocationManager', 'Admin', 'GroupManager', 'Clerk'] }
              },
              {
                path: "Backoffice",
                canActivate: [AuthGuard],
                data: { title: "Backoffice", icon: 'today', roles: ['BackOffice'] },
                children: [
                  { path: '', redirectTo: 'Insurance', pathMatch: 'full' },
                  {
                    path: "Insurance",
                    canActivate: [AuthGuard],
                    component: InsuranceReportComponent,
                    data: { title: "Insurance", icon: 'local_shipping', roles: ['BackOffice'] }
                  },
                  {
                    path: "TireChange",
                    canActivate: [AuthGuard],
                    component: TireChangeComponent,
                    data: { title: "Tire changes", icon: 'tire_repair', roles: ['BackOffice'] }
                  }
                ]
              }
            ]
          }
        ])
    ],
    providers: [T4CommonModule],
})
export class ReportModule {
    public static theme: string = "unicorn-dark-theme";
}

// Module initialization
export function initModule(settings: UIService) {
  return () => {
    settings.applySettings({ dialogs: [{ key: "T4.Report.CSEventDialog", dialog: CSEventlogDialog }] });
  };
}
// Module initialization
